// @ts-nocheck
// ====== Modal di conferma ======
function confirmAction(opts) {
  return new Promise((resolve) => {
    const modal = document.getElementById('modalConfirm');
    const dialog = modal.querySelector('.confirm-dialog');
    const titleEl = document.getElementById('confirmTitle');
    const msgEl = document.getElementById('confirmMessage');
    const detailsEl = document.getElementById('confirmDetails');
    const warnEl = document.getElementById('confirmWarning');
    const typeBox = document.getElementById('confirmTypeBox');
    const typeInput = document.getElementById('confirmTypeInput');
    const typeWord = document.getElementById('confirmTypeWord');
    const okBtn = document.getElementById('confirmOk');
    const cancelBtn = document.getElementById('confirmCancel');

    const level = opts.level || 'info';
    dialog.dataset.level = level;
    titleEl.textContent = opts.title || 'Conferma';
    msgEl.textContent = opts.message || 'Vuoi proseguire?';

    if (opts.details && opts.details.length) {
      detailsEl.innerHTML = opts.details.map((d) => `<li>${escapeHtml(d)}</li>`).join('');
      detailsEl.classList.remove('hidden');
    } else {
      detailsEl.classList.add('hidden');
    }

    if (opts.warning) {
      warnEl.textContent = opts.warning;
      warnEl.classList.remove('hidden');
    } else {
      warnEl.classList.add('hidden');
    }

    okBtn.textContent = opts.confirmText || (level === 'danger' ? 'Elimina' : 'Conferma');
    cancelBtn.textContent = opts.cancelText || 'Annulla';
    okBtn.classList.remove('btn-primary', 'btn-danger');
    okBtn.classList.add(level === 'danger' || level === 'warning' ? 'btn-danger' : 'btn-primary');

    const requireType = opts.requireType || '';
    if (requireType) {
      typeWord.textContent = requireType;
      typeInput.value = '';
      typeBox.classList.remove('hidden');
      okBtn.disabled = true;
    } else {
      typeBox.classList.add('hidden');
      okBtn.disabled = false;
    }

    function onTypeInput() {
      okBtn.disabled = typeInput.value.trim() !== requireType;
    }
    function cleanup(result) {
      modal.classList.add('hidden');
      okBtn.removeEventListener('click', onOk);
      cancelBtn.removeEventListener('click', onCancel);
      typeInput.removeEventListener('input', onTypeInput);
      modal
        .querySelectorAll('[data-confirm-close]')
        .forEach((el) => el.removeEventListener('click', onCancel));
      document.removeEventListener('keydown', onKey);
      resolve(result);
    }
    function onOk() {
      if (requireType && typeInput.value.trim() !== requireType) return;
      cleanup(true);
    }
    function onCancel() {
      cleanup(false);
    }
    function onKey(e) {
      if (e.key === 'Escape') onCancel();
      else if (e.key === 'Enter' && !okBtn.disabled && document.activeElement !== typeInput) onOk();
    }

    okBtn.addEventListener('click', onOk);
    cancelBtn.addEventListener('click', onCancel);
    typeInput.addEventListener('input', onTypeInput);
    modal
      .querySelectorAll('[data-confirm-close]')
      .forEach((el) => el.addEventListener('click', onCancel));
    document.addEventListener('keydown', onKey);

    modal.classList.remove('hidden');
    setTimeout(() => {
      if (requireType) typeInput.focus();
      else okBtn.focus();
    }, 50);
  });
}

globalThis.confirmAction = confirmAction;
export {};
